import React from 'react';
import PropTypes from 'prop-types';
import { abbreviateNumber } from 'core-utilities';

function ExchangeProgressBar({ translate, barInfo }) {
  const targetRobuxStr = abbreviateNumber.getAbbreviatedValue(barInfo.targetRobux);
  const questionStr = '???';
  return (
    <div className='graphic-container'>
      <div
        className='percent-column'
        dangerouslySetInnerHTML={{ __html: `${barInfo.percentRobux} <span>%</span>` }}
      />
      <div className='graphic-column'>
        <div className='graphic-grey' />
        <div className='graphic-green' style={{ height: `${barInfo.percentRobux}%` }} />
        <div className='cash-out-max'>{targetRobuxStr}</div>
        {barInfo.currencyOperationErrorMessage && (
          <div data-toggle='tooltip' data-original-title={barInfo.currencyOperationErrorMessage}>
            {questionStr}
          </div>
        )}
        <div className='robux-name-text'>{translate('Label.Robux')}</div>
      </div>
      <div className='clear' />
    </div>
  );
}

ExchangeProgressBar.propTypes = {
  translate: PropTypes.func.isRequired,
  barInfo: PropTypes.shape({
    percentRobux: PropTypes.number.isRequired,
    targetRobux: PropTypes.number.isRequired,
    currencyOperationErrorMessage: PropTypes.string.isRequired
  }).isRequired
};

export default ExchangeProgressBar;
